import {
  StaffPenaltyStateTypes,
  StaffPenaltyActionTypes,
} from "./StaffPenalty.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: StaffPenaltyStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const StaffPenaltyReducer = (
  state: StaffPenaltyStateTypes = INITIAL_STATE,
  action: any
): StaffPenaltyStateTypes => {
  switch (action.type) {
    case StaffPenaltyActionTypes.FETCH_ALL_STAFF_PENALTY:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case StaffPenaltyActionTypes.FETCH_ALL_STAFF_PENALTY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StaffPenaltyActionTypes.FETCH_ALL_STAFF_PENALTY_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StaffPenaltyActionTypes.FETCH_ALL_STAFF_PENALTY_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case StaffPenaltyActionTypes.FETCH_ONE_STAFF_PENALTY:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case StaffPenaltyActionTypes.FETCH_ONE_STAFF_PENALTY_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case StaffPenaltyActionTypes.FETCH_ONE_STAFF_PENALTY_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case StaffPenaltyActionTypes.FETCH_ONE_STAFF_PENALTY_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default StaffPenaltyReducer;
